import { useMemberStore, selectTyping } from '@/lib/store/member-store'
import { useAuthStore } from '@/lib/store/auth-store'
import { requireClient } from '@/lib/matrix/client'

interface TypingIndicatorProps {
  roomId: string
}

function localpart(sender: string): string {
  const match = sender.match(/^@(.+?):/)
  return match?.[1] ?? sender
}

export function TypingIndicator({ roomId }: TypingIndicatorProps) {
  const typing = useMemberStore(selectTyping(roomId))
  const userId = useAuthStore((s) => s.userId)

  const others = typing.filter((u) => u !== userId)
  if (others.length === 0) return null

  // Resolve the room display name (e.g. the contact's name) rather than showing
  // the raw user id — bridge ghosts have ids like @signal_<uuid>.
  const room = requireClient().getRoom(roomId)
  const names = others.map((u) => room?.getMember(u)?.name || localpart(u))

  return (
    <div className="px-6">
      <div className="typing-row">
        <span className="typing-dots"><i /><i /><i /></span>
        <span className="text-xs text-[rgb(var(--np-tx-muted))]">
          <b className="font-semibold text-[rgb(var(--np-tx-secondary))]">{names[0]}</b>
          {names.length === 1 ? ' is typing…' : names.length === 2 ? ` and ${names[1]} are typing…` : ` and ${names.length - 1} others are typing…`}
        </span>
      </div>
    </div>
  )
}
